export default "__VITE_ASSET__CXvlEJnV__"